import { Head } from "@inertiajs/react"
import { Suspense, lazy, useEffect, useState } from "react"

import { EditorShell } from "@/components/editor/EditorShell"
import { ScaleControls } from "@/components/editor/ScaleControls"
import { useTakeoffStore } from "@/stores/takeoff-store"

// The editor (Konva canvas) is browser-only. It is mount-gated AND lazy so the
// SSR pass never renders it and konva never enters the SSR bundle's load path.
const Editor = lazy(() => import("@/components/editor/Editor"))

function EditorLoading() {
  return (
    <div className="flex h-full items-center justify-center">
      <p className="text-ink-muted">Loading editor…</p>
    </div>
  )
}

// The bundled sample plan: a practice/demo playground with no persistence.
// Real measuring happens on takeoffs (pages/takeoffs/Show).
export default function TakeoffEditorPage({ tilesBaseUrl }: { tilesBaseUrl: string }) {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  // Fresh state every visit — the playground never persists anything.
  useEffect(() => {
    useTakeoffStore.getState().reset()
  }, [])

  const description = "Practice tracing rooms and deductions on the bundled sample plan sheet — live square footage, linear feet, and order quantities, nothing saved."

  return (
    <>
      <Head title="Sample takeoff">
        <meta name="description" content={description} />
        <meta property="og:title" content="Sample takeoff" />
        <meta property="og:description" content={description} />
      </Head>
      <EditorShell>
        <div className="flex h-full flex-col">
          <div className="flex h-10 shrink-0 items-center gap-3 border-b border-hairline bg-page px-3 text-sm">
            <span className="text-ink-muted">Sample plan — practice here, nothing saves</span>
            <span className="ml-auto flex shrink-0 items-center">
              <ScaleControls />
            </span>
          </div>
          <div className="min-h-0 flex-1">
            {mounted ? (
              <Suspense fallback={<EditorLoading />}>
                <Editor
                  key={tilesBaseUrl}
                  images={[
                    {
                      id: "sample",
                      tiles_base_url: tilesBaseUrl,
                      x: 0,
                      y: 0,
                      scale: 1,
                      width: null,
                      height: null,
                      subfloor: null,
                    },
                  ]}
                />
              </Suspense>
            ) : (
              <EditorLoading />
            )}
          </div>
        </div>
      </EditorShell>
    </>
  )
}
